// extracted by mini-css-extract-plugin
module.exports = {"bottomPadding":"cNbvLFI4ZwQFLWWhOAcJpw==","fixed":"p4pePMuuzdmjohTi5AJpAw==","alert":"niVAoCAnfuKBwnDAMori3g==","popup":"WrMA07BJI9J24yBiXaEd2Q=="};